(function($) {
	$(document).ready(function() {
		/* Mobile Menu Click Event Handle */
		$(".menu-toggle").click(function() {
			$("#main-menu-container").toggleClass("current-menu-item");
		});

    // back to top
    $(".back-to-top-btn").on("click", function() {
    	$("html, body").animate({ scrollTop: 0 }, 900);
    });

    /* social share */
    let contentWrap = document.querySelector('.mvsc__single_post_content');
    if ( contentWrap != null ) {
    	window.addEventListener('scroll', function() {
    		if ( window.pageYOffset >= contentWrap.offsetTop && window.pageYOffset <= contentWrap.offsetTop + contentWrap.clientHeight - 500 ) {
    			document.querySelector('.mvsc-social-share').classList.add('show-share-this');
    		} else {
    			document.querySelector('.mvsc-social-share').classList.remove('show-share-this');
    		}
    	});
    }
    $('.more-share-items').on('click', function() {
    	$('.mvsc-social-share').toggleClass('opend');
    });

    /* handle bar chart */
    let highChartWrap = document.querySelector('#mvsc_container');
    if ( highChartWrap != null ) {
    	Highcharts.chart("mvsc_container", {
    		chart: {
    			type: "column"
    		},
    		title: {
    			text: null
    		},
    		subtitle: {
    			text: null
    		},
    		xAxis: {
    			categories: [
    			"Overall Value",
    			"In Build Features",
    			"Design Section",
    			"Coding structure",
    			"User Friendly Design",
    			"Reports and control",
    			"SEO features",
    			"Payment Integration",
    			"Coding structure",
    			"Value for money",
    			"Support Section"
    			],
    			crosshair: true
    		},
    		yAxis: [
    		{
    			min: 0,
    			gridLineColor: "#EAEDEF",
    			title: {
    				text: null
    			}
    		}
    		],
    		tooltip: {
    			headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
    			pointFormat:
    			'<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
    			'<td style="padding:0"><b>{point.y:.1f} mm</b></td></tr>',
    			footerFormat: "</table>",
    			shared: true,
    			useHTML: true,
    			backgroundColor: "#fff"
    		},
    		plotOptions: {
    			column: {
    				pointPadding: 0.3,
    				borderWidth: 0,
    				pie: {
    					minSize: 20
    				}
    			}
    		},
    		series: [
        		{
        			name: "Dokan",
        			data: [70, 85, 90, 87, 78, 62, 68, 78, 82, 72, 58],
        			color: "#F1634C"
        		},
        		{
        			name: "CS.Cart",
        			data: [58, 78, 75, 39, 62, 44, 21, 21, 62, 58, 41],
        			color: "#02D2FE"
        		},
        		{
        			name: "Magento",
        			data: [63, 58, 69, 69, 48, 43, 62, 59, 57, 44, 30],
        			color: "#9B59B6"
        		},
        		{
        			name: "XCART",
        			data: [50, 38, 59, 47, 31, 58, 44, 39, 17, 39, 59],
        			color: "#F49D24"
        		}
    		],
    		legend: {
    			align: "right",
    			verticalAlign: "top",
    			margin: 40
    		},
    		credits: {
    			enabled: false
    		},
            tooltip: {
                headerFormat: '<span style="font-size: 10px">{point.key}</span><br/>',
                pointFormat: '<span style="color:{point.color}">●</span> {series.name}: <b>{point.y}%</b><br/>'
            },
    	});
    }
});
})(jQuery);
